import { CREATE_USER, getBusinessManagementApiUrl } from "../../constants/Urls";
import { ScheduledAnalyticsEmail } from "../../models/analytics/api/ScheduledAnalyticsEmail";
import IResult from "../../models/result/IResult";
import { sendDelete, sendGet, sendPost, sendPut } from "./generic";


export const getScheduledEmailsForOrganization = (organizationId: string): Promise<IResult<ScheduledAnalyticsEmail[]>> => {
    return sendGet<ScheduledAnalyticsEmail[]>("/ScheduledAnalyticsEmails/getScheduledOverviewEmails?" + `organizationId=${organizationId}`);
}

export const getResponsesForApplication = (appId: string, organizationId: string): Promise<IResult<ScheduledAnalyticsEmail[]>> => {
    return sendGet<ScheduledAnalyticsEmail[]>("/ScheduledAnalyticsEmails/getScheduledOverviewEmails?" + `applicationId=${appId}&organizationId=${organizationId}`);
}

export const createScheduledEmail = (email: ScheduledAnalyticsEmail): Promise<IResult<ScheduledAnalyticsEmail>> => {
    return sendPost<ScheduledAnalyticsEmail>("/ScheduledAnalyticsEmails/createScheduledOverviewEmail", email);
}

export const updateScheduledEmail = (email: ScheduledAnalyticsEmail): Promise<IResult<ScheduledAnalyticsEmail>> => {
    return sendPut<ScheduledAnalyticsEmail>("/ScheduledAnalyticsEmails/updateScheduledOverviewEmail", email);
}

export const deleteScheduledEmail = (emailId: string): Promise<IResult<any>> => {
    return sendDelete<any>("/ScheduledAnalyticsEmails/deletedScheduledOverviewEmail?" + `scheduledAnalyticsEmailId=${emailId}`);
}

export const previewScheduledEmail = (request: { organizationId: string, applicationId?: string, metricsToExclude: string[] }): Promise<IResult<any>> => {
    return sendPost<any>("/ScheduledAnalyticsEmails/previewScheduledOverviewEmail", request)
}

